<div class="fulfillment-container">
  <ng-container [ngSwitch]="state">
    <div *ngSwitchCase="'success'" class="pdf-wrapper">
      <p class="pdf-title">Documento aprobado <span>Consecutivo #{{consecutive}}</span></p>
      <iframe class="pdf-frame" [src]="pdfUrl" title="Documento aprobado" frameBorder="0"></iframe>
    </div>
    <div *ngSwitchCase="'loading'" class="loading-container"></div>
    <div *ngSwitchDefault class="not-results-container d-flex flex-column align-items-center justify-content-center">
      <div class="icon"><i class="fas fa-times-circle"></i></div>
      <div class="not-results">{{errorMessage}}</div>
    </div>
  </ng-container>
</div>
